import { Box, Grid, Button } from '@mui/material';
import CustomSnackbar from 'components/CustomSnackbar';
import DevicesListFilter from 'components/DevicesFilter/DevicesListFilter.js';
import Loading from 'components/Loading/Loading.js';
import MDTypography from 'components/MDTypography/index';
import { useEffect, useRef, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCurrentPage } from '../../stores/sensor/sensorStore';
import { BuildingCard } from './BuildingCard';
import { fetchUserBuildingsDetails } from 'stores/sensor/sensorStore';

export const BuildingsList = ({ setPdfName }) => {
  const dispatch = useDispatch();
  const { buildings_details: buildings, loading } = useSelector(state => state.sensors);
  const currentUser = useSelector(state => state.sensors.currentUser);
  const navigate = useNavigate();

  const [snackbarState, setSnackbarState] = useState({
    snackbarOpen: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal, snackbarOpen } = snackbarState;

  useEffect(() => {
    dispatch(setCurrentPage('buildings-list'));
    dispatch(fetchUserBuildingsDetails());
  }, []);

  const handleSnackbarClose = () => {
    setSnackbarState({ ...snackbarState, snackbarOpen: false });
  };

  const getDisplayTitle = 'Manage Building';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {/* ===== HEADER===== */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <MDTypography variant="h4" sx={{ ml: 0.2, color: 'black' }}>
          {getDisplayTitle}
        </MDTypography>

        <CustomSnackbar
          open={snackbarState.snackbarOpen}
          duration={3000}
          onClose={handleSnackbarClose}
          message="Please select a distributor and a customer"
          vertical={vertical}
          horizontal={horizontal}
        />
      </Box>

      {/* ===== MAIN CONTENT ===== */}
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Box ml={1} mb={1} sx={{ width: '100%' }}>
          {/* ===== FILTER COMPONENT ===== */}
          {/* <DevicesListFilter area={false} floor={false} building={false} status={false} />  */}
          {currentUser.role !== 'c' && (
            <Button onClick={() => navigate('/manage-buildings/new')}>+ Add New Building</Button>
          )}

          {/* ===== BUILDING GRID ===== */}
          <Grid
            className="buildingsListContainer"
            sx={{
              display: 'flex',
              alignItems: 'start',
              height: 'fit-content',
              maxHeight: '71vh',
              overflow: 'auto',
              width: '88vw',
              flexWrap: 'wrap',
              overflowX: 'hidden',
              pt: '.8rem',
            }}
            margin={0}>
            {buildings.map(building => (
              <Grid
                container
                sx={{
                  lineHeight: 0,
                  position: 'relative',
                  marginBottom: '1rem',
                  flexDirection: { xs: 'column', sm: 'row' },
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: { xs: 'center', sm: 'start' },
                }}
                xs={12}
                sm={12}
                md={6}
                lg={4}
                xl={3}
                key={buildings.id}>
                <BuildingCard
                  className="sensorCard"
                  id={building.id}
                  name={building.name}
                  country={building.country}
                  city={building.city}
                  street={building.street}
                  devices_count={building.devices_count}
                />
              </Grid>
            ))}
          </Grid>

          {/* ===== EMPTY STATE ===== */}
          {buildings.length === 0 && (
            <Box sx={{ textAlign: 'center', mt: 4 }}>
              <MDTypography variant="h6" color="text">
                No building found for current user
              </MDTypography>
              <MDTypography variant="body2" color="text" sx={{ mt: 1 }}>
                contact your administrator for more details
              </MDTypography>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
